module.exports = __webpack_public_path__ + "static/media/decoration_dark.31be2f10.svg";